import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./header";
import { Footer } from "./footer";
import { Sidebar } from "./sidebar";
import { useAuthStore } from "@/store/authStore";

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const { isInitialized, isLoading } = useAuthStore();

  // Pages where we don't want to show the sidebar
  const hideSidebarPages = ["/login", "/register"];
  const showSidebar = !hideSidebarPages.includes(pathname);

  // The email builder has its own full-screen chrome — hide header, sidebar & footer
  const isEmailBuilder = /^\/campaigns\/email\/[^/]+$/.test(pathname);

  // Show a full-page loading indicator while auth is being determined
  if (!isInitialized || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-primary" />
          Loading…
        </div>
      </div>
    );
  }

  return (
    <div className="lw-layout-wrapper grid min-h-screen" style={{ gridTemplateRows: 'auto 1fr auto' }}>
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      <div className="lw-layout-body flex">
        {showSidebar && (
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        )}

        <main className="lw-layout-main flex-1">
          <div
            className={`lw-layout-container container mx-auto ${showSidebar ? "px-4 py-6" : ""}`}
          >
            {children}
          </div>
        </main>
      </div>

      {!isEmailBuilder && <Footer />}
    </div>
  );
}
